export default {
  state: {
    userInfo: {}
  },
  mutations: {
    SET_USERINFO: (state, userInfo) => {
      state.userInfo = userInfo
    }
  },
  actions: {
    getInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        _api.home.getUserInfo().then(res => {
          if (res.data) {
            res.data.ext_info.avatars = res.data.ext_info.avatars.map(element => {
              element = element + '?' + new Date().getTime()
              return element
            });
            commit('SET_USERINFO', res.data)
            resolve(res)
          } else {
            reject(err)
          }
        })
      })
    }
  }
}
